import createAxios from "./axiosHttpMarconi";
export const estadosParadasService = {
  getEstados,
  saveEstado,
  getEstadoById,
  deleteEstado,
  updateEstadoParadas,
  getEstadosParadasExcel,
};

function getEstados(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/estado-parada`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0&limit=2000";
  }
  urlPath += `&sort=codigo&order=ascending`;
  urlPath += getFiltersPath(filters);
  return axios.get(urlPath);
}
function getFiltersPath(filters) {
  let urlPathFilters = "";
  if (filters && filters.codigo) {
    urlPathFilters += `&codigo=${filters.codigo}`;
  }

  if (filters && filters.tipo) {
    urlPathFilters += `&tipo=${filters.tipo}`;
  }


  if (filters && filters.descripcionOxperta) {
    urlPathFilters += `&nombre=${filters.descripcionOxperta}`;
  }
  if (filters && typeof filters.reclamacion === "boolean") {
    urlPathFilters += `&reclamacion=${filters.reclamacion}`;
  }
  return urlPathFilters;
}

function saveEstado(body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/estado-parada`;
  return axios.post(urlPath, body);
}

function getEstadoById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/estado-parada/${id}`;
  return axios.get(urlPath);
}

function updateEstadoParadas(body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/estado-parada/${body._id}`;
  return axios.put(urlPath, body);
}

function getEstadosParadasExcel(filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/estado-paradas/excel?limit=2000`;
  urlPath += getFiltersPath(filters);
  return axios.get(urlPath, { responseType: "blob" }).catch(async (error) => {
    const data = await error.text();
    throw JSON.parse(data);
  });
}

function deleteEstado(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  return axios.delete(`/franquiciadora/${user.extraData.franquiciadoraId}/estado-parada/${id}`);
}
